import React, { createContext } from 'react'
import { BaseContextState, BaseContextProvider } from '../BaseContext'
import { SearchRequest } from '../../services/api/interfaces/ApiRequest'
import { creditsCreate, creditsList } from '../../services/api'

interface CreditsContextState extends BaseContextState {
  credits: any[] | null,
  credit: any | null,
  filters?: any
}

export interface CreditsContextData extends CreditsContextState {
  resetErrors: Function,
  requestCreditsList: (args: SearchRequest) => Promise<any>,
  requestCreditsFind: (args: SearchRequest) => Promise<any | null>,
  requestCreditsCreate: (args: any) => Promise<any | null>,
}

// Create context
const { Provider, Consumer } = createContext({} as CreditsContextData)

// Export consumer
export const CreditsConsumer = Consumer

export class CreditsProvider extends BaseContextProvider {
  state: CreditsContextState = {
    credits: null,
    filters: null,
    credit: null
  }

  /**
   * Make api request for invoice list
   * 
   * @param {SearchRequest} payload 
   */
  requestCreditsList = (payload: SearchRequest) => {
    this.setState({filters: payload})
    return new Promise((resolve, reject) => {
      this.setState({
        fetching: true,
        error: null,
        credits: null
      }, async () => {
        const response = await creditsList(payload)
  
        // Process our response
        this.processResponse(response, { 
          paginate: {
            destination: 'credits'
          },
        })

        if (this.state.success) {
          resolve(true)
        } else {
          reject(this.state.error)
        }
      })
    })
  }

  /**
   * Make api request for invoice finder
   * 
   * @param {SearchRequest} payload 
   */
  requestCreditsFind = (payload: SearchRequest): Promise<any | null> => {
    return new Promise((resolve, reject) => {
      this.setState({
        fetching: true,
        error: null,
        credit: null
      }, async () => {
        payload.options = {
          ...payload.options,
          _single: true
        }
        const response = await creditsList(payload)
  
        // Process our response
        this.processResponse(response, { 
          mappings: {
            destination: 'credit'
          },
        })

        if (this.state.success) {
          resolve(this.state.credit)
        } else {
          reject(this.state.error)
        }
      })
    })
  }

 
  requestCreditsCreate = (payload: any): Promise<any | null> => {
    return new Promise((resolve, reject) => {
      this.setState({
        fetching: true,
        error: null,
      }, async () => {
        const response = await creditsCreate(payload)

        this.processResponse(response, {
          mappings: {
            destination: 'credit'
          },
        })

        if (this.state.success) {
          resolve(true)
        } else {
          reject(this.state.error)
        }
      })
    })
  }

  render() {
    return (
      <Provider
        value={{
          // States
          ...this.state,

          // Dispatches
          resetErrors: this.resetErrors,
          requestCreditsList: this.requestCreditsList,
          requestCreditsFind: this.requestCreditsFind,
          requestCreditsCreate: this.requestCreditsCreate,
        }}
      >
        {this.props.children}
      </Provider>
    )
  }
}
